import { Component, OnInit } from '@angular/core';
import { HostComponent } from '../host/host.component';
import { LogonResponse, PreAuthenticationResponse } from '@picard/models-lib';
import { StorageConstants } from '@picard/shared-lib';
import { Router } from '@angular/router';
import { ApplicationService } from '@picard/services-lib';
// ToDo: Move this to the helpers in the shared lib.
function isEmptyOrSpaces(str) {
  return str === null || str.match(/^ *$/) !== null;
}
@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.css']
})
export class TopbarComponent implements OnInit {
  //#region Properties
  user: string;
  preAuthenticationResponse: PreAuthenticationResponse;
  programId: number;
  //#endregion Properties

  //#region Constructor
  constructor(public hostComponent: HostComponent, private _applicationService: ApplicationService, private _router: Router) {
    this.programId = parseInt(sessionStorage.getItem('programID')); // this._applicationService.preAuthenticationResponse.programId;
  }
  //#endregion Constructor

  //#region Functions
  ngOnInit() {
    this.preAuthenticationResponse = JSON.parse(sessionStorage.getItem(StorageConstants.preAuth));
    const logonResponse: LogonResponse = JSON.parse(sessionStorage.getItem(StorageConstants.loginDetails));
    const firstname = isEmptyOrSpaces(logonResponse.usersModel.firstname) ? '' : logonResponse.usersModel.firstname;
    const surname = isEmptyOrSpaces(logonResponse.usersModel.surname) ? '' : logonResponse.usersModel.surname;
    const userValue = `${firstname} ${surname}`;
    if (isEmptyOrSpaces(userValue)) {
      if(this.programId === 2555)
        {
          this.user = `Welcome: ${logonResponse.usersModel.mobileNumber}`;
        }else{this.user = `Welcome: ${logonResponse.usersModel.userId}`;}
    } else {
      this.user = `Welcome: ${userValue}`;
    }
  }
  onLogoff() {
    let route = '';
    // // ToDo: Check the route here once it has been added to the table and the preAuthenticationResponse object.
    // if (this.preAuthenticationResponse.description) {
    //   route = this.preAuthenticationResponse.description;
    // }
    sessionStorage.clear();
    localStorage.clear();
    if (route === '') {
      this._router.navigateByUrl(`/login`);
    } else {
      this._router.navigateByUrl(route);
    }
  }
  //#endregion Functions
}
